import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  placeholder: string;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
  name?: string;
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
  maxLength?: number;
  isDaysTextField?: boolean;
  type?: string;
}

interface StyledInputProps {
  helperText?: string;
}

interface StyledLabelProps {
  isDaysTextField?: boolean;
}

const Textfield = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  required,
  helperText,
  disabled,
  maxLength,
  isDaysTextField,
  type = "string",
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label isDaysTextField={isDaysTextField}>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <InputField
          disabled={disabled}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          type={type}
          name={name}
          helperText={helperText}
          autoComplete="off"
          maxLength={maxLength}
          // @ts-ignore
          onWheel={(e) => e.target.blur()}
        />
        {helperText && <Error>{helperText}</Error>}
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const InputField = styled.input<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 12px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  touch-action: none;
  border: 1px solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;
const Label = styled.label<StyledLabelProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${(props) =>
    props.isDaysTextField ? Colors.logan : Colors.electricBlue};
  margin-bottom: 0.25rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default Textfield;
